import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ISmeLoanState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: ISmeLoanState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: ISmeLoanState = initialState,
  action: ActionWithPayload<ISmeLoanState>
) => {
  switch (action.type) {
    case actionTypes.GET_SME_LOAN_START:
      return {...state, loading: true}
    case actionTypes.GET_SME_LOAN_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_SME_LOAN_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
